import styled from 'styled-components'

export const StyledCarousel = styled.div`
  height: 100%;
  width: 100%;
  max-width: 1024px;
  .awssld__content {
    background: #f0f0f0;
  }
  .awssld__next:after {
    ${({ isEdge }) => isEdge ? 'content: \'\'' : 'empty'};
        width: 50px;
    height: 50px;
    transform: translateX(-50%) rotate(-45deg);
    border-bottom: 5px solid black;
    border-right: 5px solid black;
  }
  .awssld__prev:after {
     ${({ isEdge }) => isEdge ? 'content: \'\'' : 'empty'};
    width: 50px;
    height: 50px;
    transform: translateX(50%) rotate(-45deg);
    border-top: 5px solid black;
    border-left: 5px solid black;
  }
  @media (max-width: 700px) {
    .awssld__container {
      padding-bottom: 125%;
    }
    div {
      padding: 0.25rem;
    }
  }
  
  .carouselSlide {
  display: flex;
  align-items: center;

  h2 {
    font-weight: bold;
    font-size: 1.4em;
  }
  * {
    margin-top: 0;
    text-align: left;
    color: black;
    line-height:1.2;
    font-size: 1.1em;
  }

  a {
    font-size: 1em;
  }
    height: 100%;
    position:absolute;
    top:0;
    @media(orientation: landscape){
    max-width: 60%;
    }
    @media(orientation: portrait){
    max-width: 90%;
    font-size: 0.8em;
    }
  }

  @media(orientation: portrait){
    max-width: 90%;
    }
`
export const StyledCarouselSlide = styled.div`
  width: 300px;

  @media(orientation: portrait){
    width: 90%;
    }
`
